import { Link } from 'react-router-dom';

export function CheckTeaserSection() {
  const stats = [
    { icon: 'ri-mail-warning-line', label: 'Phishing' },
    { icon: 'ri-message-2-line', label: 'Smishing' },
    { icon: 'ri-phone-line', label: 'Vishing' },
  ];

  return (
    <section className="relative py-24">
      <div className="container mx-auto px-6 max-w-5xl">
        <div className="bg-gradient-to-br from-blue-500/10 to-cyan-500/5 border border-blue-500/30 rounded-3xl p-10 md:p-14">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 border border-blue-500/30 rounded-full px-4 py-1 mb-6">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
                <span className="text-sm text-blue-300">Free · ~3 minutes</span>
              </div>

              <h2 className="text-4xl md:text-5xl font-light text-white mb-4 leading-tight">
                Can you spot a{' '}
                <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                  social engineering attack?
                </span>
              </h2>

              <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                Take our quick vulnerability check. Nine real-world scenarios across phishing, smishing and vishing — see how sharp your defences really are.
              </p>

              <Link
                to="/check"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="inline-flex items-center group px-8 py-4 rounded-full text-lg font-medium transition-all duration-300 cursor-pointer bg-white text-black hover:bg-blue-400 hover:text-white"
              >
                Take the check
                <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300">→</span>
              </Link>
            </div>

            <div className="space-y-3">
              {stats.map((item) => (
                <div
                  key={item.label}
                  className="flex items-center gap-4 bg-black/40 border border-white/10 rounded-2xl px-6 py-4 backdrop-blur-sm"
                >
                  <div className="w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/30 flex items-center justify-center">
                    <i className={`${item.icon} text-2xl text-blue-400`}></i>
                  </div>
                  <div>
                    <div className="text-white font-medium">{item.label}</div>
                    <div className="text-sm text-gray-400">Spot it before it lands</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
